// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aI1efoCmQjwU6OMXXa9X{flex:1;gap:12px;min-width:344px;padding:12px;display:flex}.UGwDtvGHx3ssr_t8ZSM7{flex:1;align-items:center;gap:8px;display:flex}.IJ6f3WeBUs6RkTFm3SHn{width:120px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `aI1efoCmQjwU6OMXXa9X`,
	"timeSelector": `UGwDtvGHx3ssr_t8ZSM7`,
	"inputTimePicker": `IJ6f3WeBUs6RkTFm3SHn`
};
export default ___CSS_LOADER_EXPORT___;
